// Geotab Go Focus Plus Domain Configuration
export const geotabgofocusplusConfig = {
  // Basic domain information
  id: 'geotabgofocusplus',
  name: 'Geotab GO Focus Plus',
  tagline: 'Advanced Fleet Camera Solution with Enhanced Focus',
  description: 'Professional camera system with enhanced focus capabilities for superior fleet safety and security. Industry-leading, video telematics in an all-in-one safety solution, proven to reduce collision rates and lower risk.',
  
  // Assets
  logo: '/assets/logos/geotabgofocusplus-logo.png',
  whiteLogo: '/assets/logos/geotabgofocusplus-white-logo.png',
  favicon: '/assets/favicons/geotabgofocusplus-favicon.png',
  icon: '/assets/icons/geotabgofocusplus',
  
  // Navigation
  pages: ['home', 'solutions', 'resources', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Resources', path: '/resources' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy Now'
  },
          
  // Shop link
  shopLink: 'https://shop.fleethoster.com/products/dcc12-gofocus-plus',

  // UI Configuration
  variant: 'corporate',
  showFeatures: true,
  showTestimonials: true,
  
  // Content sections
  hero: {
    title: 'Geotab GO Focus Plus Camera',
    subtitle: 'Professional camera solution designed with enhanced focus technology for optimal fleet monitoring and safety.',
    features: [
      'Compact and rugged: AI dash cams specialized for diverse fleet needs.', 
      'Improve driver behavior and visibility: Unified video and telematics fully integrating with MyGeotab ', 
      'Easy to install, self-calibrating: Fast, simple setup to get your fleet running quickly.'
    ]
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Geotab GO Focus Plus Gallery',
    subtitle: 'Explore our professional camera with advanced focus capabilities',
    description: 'See how GO Focus Plus transforms fleet safety with superior camera technology'
  },

  features: {
    title: 'Advanced Geotab Camera Features',
    subtitle: 'Professional Fleet Camera Solutions with Enhanced Focus',
    description: 'GO Focus Plus camera system with enhanced focus capabilities provide unmatched visibility, security, and peace of mind for your fleet operations.',
    items: [
      {
        title: 'Collision prevention',
        description: 'Video evidence helps in analyzing incidents and implementing measures to prevent future collisions.',
        icon: '🚗'
      },
      {
        title: 'Protecting drivers',
        description: 'Cameras capture driving behavior in real time to promote safer driving habits and reduce risk.',
        icon: '👨‍🚒'
      },
      {
        title: 'Risk reduction',
        description: 'Video footage provides indisputable evidence in case of false claims or disputes, protecting your company from fraudulent activities.',
        icon: '⚖️'
      },
      {
        title: 'Cost savings',
        description: 'Reduce expenses related to accidents, insurance claims, and vehicle damage by proactively managing and mitigating risks.',
        icon: '💰'
      }
    ]
  },
  
  solutions: {
  title: 'Geotab GO Focus Plus Solution',
    subtitle: 'Industry-leading, video telematics in an all-in-one safety solution, proven to reduce collision rates and lower risk.',
    description: 'Geotab GO Focus Plus with enhanced focus technology provide 360-degree visibility, AI-powered analytics, and seamless integration with your existing fleet management system.',
    sections: [
      {
        title: 'Improve safety with dash cams for trucks and fleets',
        description: 'The GO Focus AI dash cam family helps fleets minimize risk and improve driver performance by capturing and analyzing risky events with ADAS and AI. \n \nOur safety solution includes road-facing-only options with ADAS as well as road and in-cab driver monitoring systems (DMS). \n \nFor a more streamlined safety option, GO Focus only records road footage for collisions and tailgating. \n \nGO Focus Plus offers both default and custom road and in-cab event detection, combining telematics and video on the edge, needed for a comprehensive safety program. \n \nEither way, you get seamless access to real-time trip information, images and video directly from the MyGeotab platform.'
      },
      {
        title: 'Protect your business with fleet camera systems',
        description: "The GO Focus family series of dash cams deliver high-definition video evidence that proves what happened in collisions and insurance disputes. Reliable footage helps accurately represent events, prevent exaggerated claims and exonerate drivers who are not at fault. Transparent incident documentation helps fleets avoid nuclear verdicts and protect against fraud. \n \nFor additional security and fleet safety, auxiliary cameras can be connected to monitor vehicle interiors, equipment and other high-value assets."
      },
      {
        title: 'Critical events + video coaching in one',
        description: 'GO Focus Plus AI dash cam cuts wasted hours from review. High-risk actions, like fatigue, tailgating and hard braking, trigger instant in-cab voice alerts for drivers, helping build better habits in real time. For managers, the most critical events are surfaced first with video and context, making it easy to review urgent risks and coach effectively in one streamlined workflow. The system analyzes events right in the vehicle delivering faster alerts, keeping data secure and improving automatically with every use.'  
      },
      {
        title: 'Get comprehensive data and strengthen your safety program with AI fleet dash cams',
        description: 'Choose from an industry leading range of easy-to-install, easy-to-use cameras, fully integrated with the Geotab platform. \n \nWith fleet dash cams you can:\n• Gain visibility into on-road activities, including aggressive and distracted driving \n• Record driving routes \n• Use video to support driver coaching and training \n• Record and save video evidence of collisions \n• Receive immediate text or email notification of incidents \n• Watch live playback of events \n• See trip and map information \n• Share videos via web link',
      },
      {
        title: 'Coaching workflow that makes every alert count',
        description: 'With GO Focus Plus, a critical event becomes a driver coaching opportunity inside MyGeotab. Managers see video context, risk level, and recommended next steps—all at a glance. Assign feedback, track driver progress, and recognize improvement with a workflow built for fleet realities. Severity-based dashboards surface the drivers and behaviors that need attention most, so managers act faster and close the loop on risk. Results stay visible, and safer driving habits take hold fleet-wide.',
      }
    ]
  },
  
  
  testimonials: [
    {
      content: "The enhanced focus technology in Geotab Go Focus Plus has revolutionized our fleet safety program. The crystal-clear footage and advanced analytics help us identify and address potential risks before they become incidents. It's been a game-changer for our driver safety initiatives.",
      author: "Sarah Mitchell",
      role: "Fleet Safety Manager",
      company: "",
      avatar: "https://randomuser.me/api/portraits/women/32.jpg"
    },
    {
      content: "We've built an excellent partnership with the Geotab Go Focus Plus team. Their enhanced focus technology and advanced analytics have helped us achieve significant improvements in our fleet safety metrics. The system's ability to focus on critical situations has been invaluable.",
      author: "David Chen",
      role: "Operations Director",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/38.jpg"
    }
  ],

  blog: {
    title: 'Geotab Go Focus Plus Blog',
    subtitle: 'Latest News and Insights',
    description: 'Stay informed with the latest news and insights in fleet management technology.',
  },

  resourceCenter: {
    title: 'Geotab GO Focus Plus Resource Center',
    subtitle: 'Expert guides and educational resources',
    description: 'Everything you need to know about Geotab GO Focus Plus camera systems and safety solutions.',
    showComparePrices: false,
    hero: {
      title: 'Geotab GO Focus Plus Resource Center',
      subtitle: 'Complete Guide to Geotab GO Focus Plus Camera Systems',
      description: 'Comprehensive guides, expert insights, and frequently asked questions about Geotab GO Focus Plus camera systems and safety solutions.',
    },
    sections: [
      {
        title: 'How do fleet dash cams work?',
        description: '',
        items: [
          '1. Dash cam starts recording video. Our dash cams operate using power from vehicle batteries via a wired connection. Cameras will only start recording when a vehicle engine is turned on and in motion to avoid unnecessary battery drain.',
          '2. AI connected sensors capture risky driving events. HD footage is recorded constantly when a vehicle is in motion. Footage is captured day or night with infrared LEDs for clear quality video and wide angle lenses for both road facing and driver facing cameras.',
          '3. High-definition footage and alert data are saved to the cloud. Driver journey footage and alerting data are uploaded to the cloud, so fleet managers can view video and image data at any time.',
          '4. Fleet managers can easily review pictures and videos within MyGeotab. You’ll be alerted when video is available to watch and download on the MyGeotab platform. See HD dash cam footage alongside GPS data so you know who the driver was, how fast they were going and where they were located.',
        ]
      }
    ],

    faqs: [
      {
        question: 'What is ADAS and DMS?',
        answer: 'Advanced Driver Assistance Systems (ADAS) are electronic systems in vehicles that use AI to aid the driver. They include features like lane departure warning, adaptive cruise control and automatic emergency braking. Driver Monitoring Systems (DMS) are systems that use cameras and AI sensors to monitor driver attentiveness, fatigue and behavior to improve safety on the road.',
      },
      {
        question: 'What is computer vision?',
        answer: 'Computer vision is a field of AI that enables computers to interpret and understand visual information from images and videos. In vehicle cameras, computer vision is used for tasks such as object detection and recognition. '
      },
      {
        question: 'What is edge computing?',
        answer: 'For fleets, edge computing means processing data, such as video footage, alerts, and sensor readings, directly within the vehicle, instead of sending everything to a central server. This enables faster response times for safety events, real-time alerts, and more efficient use of bandwidth.',
      },
      {
        question: 'What fleet dash cam options does Geotab have?',
        answer: 'Geotab offers the GO Focus family of dash cams, including GO Focus Plus with in-cab feedback, targeted coaching, and advanced event review, as well as GO Focus for road-facing video and privacy-focused recording during key events. These options provide flexible solutions to meet a wide range of fleet safety needs. For additional requirements, the Geotab Marketplace features a broad selection of dash cam and ADAS solutions from leading partners, covering everything from dual road and driver-facing cameras to auxiliary setups for expanded coverage. Find our available camera solutions on the Geotab Marketplace.',
      },
      {
        question: 'Why are dash cams important for commercial fleets?',
        answer: 'There are many reasons why fleet camera systems are important for commercial fleets. \n \nThey can help:\n• Save commercial businesses money by using video evidence for fraudulent claims and exonerating drivers \n• Offer 360 degree operational visibility with in-cab and exterior cameras \n• Identify harsh driving incidents to personalize driver coaching and increase driver engagement \n• Reduce the number of collisions by sending instant alerts to drivers when they are lane drifting or driving too close to other vehicles \n• Pick up on driver behaviors like cell phone use, smoking, eating or driver fatigue using AI',
      },
      {
        question: 'What is the advantage of Geotab’s dash cam solutions?',
        answer: 'The main advantage of Geotab’s dash cam solutions is flexibility and choice.\n\nWith the GO Focus family, fleets can select solutions tailored to their needs, such as in-cab alerts, event-based video recording, and automated coaching features. Geotab also supports integration with a wide range of third-party dash cams and advanced driver assistance systems through the Geotab Marketplace.\n\nFleets can manage all video and telematics data in one unified platform, and in many cases existing camera hardware can also be supported.'
      },
      {
        question: 'How do fleet dash cam systems work? When is video saved?',
        answer: 'Fleet dash cam systems use connected cameras to capture video.\n\nWhen video is saved depends on telematics or ADAS/DMS event triggers such as tailgating, phone usage, rolling stops, speeding, and other customizable behaviors.\n\nThe saved video is available for review through a user interface that is integrated with MyGeotab.'
      },
      {
        question: 'What camera data is recorded with an event?',
        answer: 'Most camera solutions allow fleets to choose from four recording options:\n\n• Snapshot and video – Records both a snapshot and a video\n• Snapshot – Records only a snapshot\n• Video – Records only a video\n• Disabled – Does not record a snapshot or video'
      },
      {
        question: 'Can I download the videos?',
        answer: 'Most fleet dash cam solutions allow digital downloads of recordings, although features vary by provider.\n\nTo learn more about Geotab’s fleet dash cam solutions and available features, you can visit the Camera and ADAS section of the Geotab Marketplace.'
      },
      {
        question: 'How do you install Geotab-integrated fleet dash cams?',
        answer: 'Some camera solutions can be installed through self-installation, while others require a certified professional installer.\n\nFleets should consult with their Geotab Reseller to determine the best installation option for their specific needs.'
      },
      {
        question: 'What features do Geotab-integrated dash cams come with?',
        answer: 'Features vary by solution and may include live streaming, on-demand video, infrared, ADAS, and more.\n\nFleets can choose a solution based on the features and use cases most relevant to their operations.'
      },
      {
        question: 'How long does footage stay on the dash cam?',
        answer: 'Footage retention varies depending on the solution.\n\nStorage capacity can often be expanded or adjusted based on customer requirements by working with Marketplace Partners.'
      },
      {
        question: 'How do I check my dash cam footage?',
        answer: 'Dash cam footage can be viewed and managed through the MyGeotab platform for GO Focus devices.\n\nMany Marketplace solutions also offer integrated video viewing inside MyGeotab, allowing fleets to review events without logging into a separate system.'
      },
      {
        question: 'Can a fleet dash cam integrate with GPS tracking?',
        answer: 'Yes, fleet camera, video, and ADAS solutions available through the Marketplace integrate with MyGeotab.\n\nThis allows fleets to view and manage video alongside GPS and telematics data in a single dashboard. Some partner solutions also integrate with Geotab rules and exceptions to control when video is captured or bookmarked.'
      },
      {
        question: 'Are Geotab fleet dash cams suitable for all types of commercial vehicles?',
        answer: 'Yes, the GO Focus family and other fleet camera solutions are designed for a wide range of commercial vehicles, including heavy-duty, medium-duty, and light-duty trucks, vans, and passenger vehicles.'
      },
      {
        question: 'How can fleet dash cams help with driver safety?',
        answer: 'Fleet dash cams can improve driver safety in several ways:\n\n• Provide visibility into aggressive or distracted driving\n• Support driver coaching and training using real video events\n• Deliver in-cab coaching for real-time corrective feedback\n• Record collision evidence to reduce false insurance claims\n• Send real-time text or email alerts for incidents and near misses\n\nFleets can choose solutions that best match their safety and operational priorities through the Marketplace.'
      },
      {
        question: 'Do the cameras operate through Wi-Fi?',
        answer: 'Connectivity varies by solution.\n\nSome cameras use Wi-Fi while others operate via Bluetooth or other wireless technologies. Specific connection methods depend on the camera provider.'
      },
      {
        question: 'Does a dash cam drain the vehicle battery?',
        answer: 'Fleet dash cams consume very little power and are generally safe for vehicle battery life.\n\nPower usage can vary slightly by solution, but most are designed to be energy efficient.'
      },
      {
        question: 'How long after unsafe driving occurs can I review the video?',
        answer: 'This depends on the camera solution.\n\nSome systems offer real-time streaming and instant alerts, while others upload video after the event has occurred. Upload timing and review availability vary by provider.'
      }
    ],
  },

  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Geotab GO Focus Plus | Enhanced Fleet Camera Solutions',
    description: 'Ensure fleet safety with Geotab GO FOCUS PLUS cameras: HD recording, night vision, GPS tracking, and secure cloud storage.',
    keywords: [
      'Geotab Go Focus Plus', 'enhanced focus cameras', 'fleet cameras', 'fleet safety', 'camera systems', 'fleet management',
      'Geotab Go Focus Plus camera systems', 'enhanced focus fleet cameras', 'vehicle cameras', 'fleet monitoring', 'camera solutions',
      'fleet safety cameras', 'professional cameras', 'enhanced focus technology', 'camera analytics', 'Geotab GO Solutions',
      'fleet video recording', 'fleet security systems', 'camera monitoring', 'fleet protection', 'advanced focus cameras', 'Geotab', 'GO Focus Plus',
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Geotab GO Focus Plus - Enhanced Focus Fleet Camera Solution',
    ogDescription: 'Ensure fleet safety with Geotab GO FOCUS PLUS cameras: HD recording, night vision, GPS tracking, and secure cloud storage.',
    ogType: 'website',
    ogUrl: 'https://www.geotabgofocusplus.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Geotab GO Focus Plus - Enhanced Focus Fleet Camera Solution',
    twitterDescription: 'Ensure fleet safety with advanced camera systems: HD recording, night vision, GPS tracking, and secure cloud storage.',
    
    // Robots
    robots: 'index, follow',
    author: 'Geotab Go Focus Plus',
    publisher: 'Geotab Go Focus Plus',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Geotab GO Focus Plus | Enhanced Fleet Camera Solutions',
        description: 'Ensure fleet safety with Geotab GO FOCUS PLUS cameras: HD recording, night vision, GPS tracking, and secure cloud storage.',
        keywords: ['Geotab Go Focus Plus', 'enhanced focus cameras', 'fleet safety', 'camera systems', 'fleet security']
      },
      solutions: {
        title: 'Geotab GO Focus Plus | Safety, Coaching, Video Telematic',
        description: 'Comprehensive Geotab GO FOCUS PLUS camera solutions with AI analytics, professional installation, and 24/7 fleet monitoring',
        keywords: ['Geotab Go Focus Plus solutions', 'enhanced focus fleet security', 'camera installation', 'fleet monitoring']
      },
      products: {
        title: 'Geotab GO Focus+ Blog | AI Coaching Tips, Safety Guides & Updates',
        description: 'Ensure fleet management efficiency with Geotab GO FOCUS PLUS cameras: HD recording, night vision, cloud storage, and enhanced focus technology',
        keywords: ['Geotab Go Focus Plus products', 'enhanced focus fleet camera equipment', 'HD cameras', 'night vision systems']
      },
      blog: {
        title: 'Geotab GO Focus Plus Blog | AI Coaching & Safety Guides',
        description: 'Latest news and insights on Geotab GO FOCUS PLUS cameras with enhanced focus technology for fleet security and professional tips.',
        keywords: ['Geotab Go Focus Plus news', 'enhanced focus fleet security insights', 'camera best practices', 'fleet safety tips']
      },
      resources: {
        title: 'Geotab GO Focus Plus | Installation Guides & FAQs',
        description: 'Everything you need to know about Geotab Go Focus Plus camera systems and safety solutions.',
        keywords: ['Geotab Go Focus Plus resources', 'camera systems', 'safety solutions']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
